// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6346":"b72a8383","8610":"3026d5ff","9622":"3026d5ff"}[chunkId] + ".chunk.css";
};